import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** */
let PitActivityEntityInvertLink = class PitActivityEntityInvertLink {
    get masterEntityCode() {
        return this._masterEntityCode;
    }
    set masterEntityCode(value) {
        this._masterEntityCode = value;
    }
    get masterEntityId() {
        return this._masterEntityId;
    }
    set masterEntityId(value) {
        this._masterEntityId = value;
    }
    get masterEntityName() {
        return this._masterEntityName;
    }
    set masterEntityName(value) {
        this._masterEntityName = value;
    }
    get masterEntityTypeId() {
        return this._masterEntityTypeId;
    }
    set masterEntityTypeId(value) {
        this._masterEntityTypeId = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get entityLinkId() {
        return this._entityLinkId;
    }
    set entityLinkId(value) {
        this._entityLinkId = value;
    }
    get linkTypeId() {
        return this._linkTypeId;
    }
    set linkTypeId(value) {
        this._linkTypeId = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "masterEntityCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityEntityInvertLink.prototype, "_masterEntityCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "masterEntityId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityInvertLink.prototype, "_masterEntityId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "masterEntityName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityEntityInvertLink.prototype, "_masterEntityName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "masterEntityTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityInvertLink.prototype, "_masterEntityTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityEntityInvertLink.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "entityLinkId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityInvertLink.prototype, "_entityLinkId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "linkTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityEntityInvertLink.prototype, "_linkTypeId", void 0);
PitActivityEntityInvertLink = tslib_1.__decorate([
    jsonObject
], PitActivityEntityInvertLink);
export { PitActivityEntityInvertLink };
